import { Component, OnInit } from '@angular/core';
import { SaleItemService } from '../sale-item.service';
import { SaleService } from '../sale.service';
import { ProductStorageService } from '../../product_storages/product-storage.service';
import { ContractorService } from '../../contractors/contractor.service';
import { ContactService } from '../../contacts/contact.service';
import { Message } from 'primeng/primeng';
import { GlobalDataService } from '../../../../services/global-data.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { PositionService } from '../../positions/position.service';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

@Component({
  selector: 'app-sale-items',
  templateUrl: './sale-items.component.html',
  styleUrls: ['./sale-items.component.css'],
  providers: [
    SaleItemService,
    SaleService,
    PositionService,
    ContractorService,
    ProductStorageService,
    ContactService
  ],
  preserveWhitespaces: false
})


export class SaleItemsComponent implements OnInit {

  id: any = null;
  productsForGrid: any = [];
  salesCartGrid: any = [];
  msgs: Message[] = [];
  contractor: any = [];
  _sale_type: any = [];
  _searchGrid: boolean = false;
  _product_name: any = "";
  _display: boolean = false;
  store_id: any;
  loading: boolean = true;
  loadingQuickRegistr: boolean = false;
  countProductModal: boolean = false;
  productNameModal: string = "";
  productSkuModal: string = "";
  productIdModal: string = "";
  productCountModal: any;
  productItemIdModal: any;
  productIndexModal: any;
  saleTypeModal: any;
  storeIdModal: any;
  total: any;
  sumTotal: any = 0;
  convertedSumTotal: any = 0;

  contractorSaldo: any = 0;

  debt: number = 0;
  paidValue:number = 0;
  paidPurpose: string = "";
  contractors: any[] = [];
  contacts: any[] = [];
  contact: any = {};

  selectedContractor:any;

  quickRegistrModal: boolean = false;
  messageDisplay: boolean = false;
  deleteIndex: any;
  blocked: boolean = false;
  issueButtonDisabled: boolean = true;

  saleCart: any[] = [];

  saleItemCart: any[] = [];
  saleItemCartLoading: boolean = false;

  saleItemCartServer: any[] = [];
  saleItemCartServerLoading: boolean = false;


  saleItemSearchCartVisible: boolean = false;
  saleItemSearchCartLoading: boolean = false;
  saleItemSearchCart: any[] = [];

  textSku: any;
  textName: any;

  selectedContact: string;
  selectedContactDriver: string;
  deadlineReplenishment: any;

  selectedSaleCartItems:any=[];


  constructor(
    private saleItemService: SaleItemService,
    private saleService: SaleService,
    private positionService: PositionService,
    private productStorageService: ProductStorageService,
    private contractorService: ContractorService,
    private contactService: ContactService,
    private _location: Location,
    private global: GlobalDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router) {

    // this._sale_type.push({label:'Розничная', value:{id:1, name: 'Розничная', code: '1'}});  
    // this._sale_type.push({label:'Оптовая', value:{id:2, name: 'Оптовая', code: '2'}});	
    activatedRoute.params.subscribe(params => { this.id = params['id'] });
    console.log(this.id);
    if (this.id) {
      this.onLoad();
    }
    // this.loadSaleCartGrid(this.id);	

  }

  ngOnInit() {


    this.calculateSumTotal();

    this.contact = {
      middle_name: "",
      first_name: "",
      genders: [],
      positions: [],
      contractors: []
    }


    if (localStorage.getItem('sales')) {
      this.saleCart = JSON.parse(localStorage.getItem('sales'));
      this.contractorService.getContractorById(this.saleCart[this.id].contractor.id).subscribe(response => { this.contractor = response['data']; this.contractorSaldo = this.contractor.account && this.contractor.account.saldo; });
    }

    Observable.forkJoin(
      this.contactService.getContactListByFilter([{ name: 'contractor_id', value: this.saleCart[this.id].contractor.id }]),
      this.contactService.getContactListByFilter([{ name: 'contractor_id', value: '62e26f37-f6b0-4452-a4fb-e40fa1cd6b86' }])
    ).subscribe(response=>{
     let contact1 = response[0]['data'].map(function (value: any) {
            return { label: value.full_name, value: value.id };
          });
     let contact2 = response[1]['data'].map(function (value: any) {
       return { label: value.full_name, value: value.id };
     });
          this.contacts = contact1.concat(contact2);
    })

    // this.contactService.getContactByFilter([{ name: 'contractor_id', value: this.saleCart[this.id].contractor.id }]).subscribe(response => {
    //   this.contacts = response['data'].map(function (value: any) {
    //     return { label: value.full_name, value: value.id };
    //   });
    // })
    // this.contactService.getContactByFilter([{ name: 'contractor_id', value: '62e26f37-f6b0-4452-a4fb-e40fa1cd6b86' }]).subscribe(response => {
    //   this.contacts = response['data'].map(function (value: any) {
    //     return { label: value.full_name, value: value.id };
    //   });
    // })

    // this.=this.global.user.stores[0].id;
    // this.contractorService.getContractor().subscribe(response=>{this.contractor=response['data'].map(function(value: any){
    // return {label:value.name, value: value.id};
    // })
    // })

  }

  onLoad() {
    console.log('onLoad');
    this.saleItemCartLoading = true;
    if (localStorage.getItem('sales')) {
      this.saleCart = JSON.parse(localStorage.getItem('sales'));
      if (JSON.parse(localStorage.getItem('sales'))[this.id]['items']) {
        this.saleItemCart = JSON.parse(localStorage.getItem('sales'))[this.id]['items'];
        this.saleItemCart = this.saleItemCart.map((value, index) => { value.index = index; return value; })
      }
      this.store_id=this.saleCart[this.id].store_id;
    }
    this.saleItemCartLoading = false;

  }

  loadContacts(){

  }

  onEditComplete(data){
    console.log(data);
    let index =data.index;
    this.saleItemCart[index].count = data.count;
    this.saleItemCart[index].total = (data.count* this.saleItemCart[index].retail_price).toFixed(2);
    this.saleItemCart[index].total_converted_retail_price = (data.count * this.saleItemCart[index].converted_retail_price).toFixed(2);
    this.calculateSumTotal();
    this.save();
  }

  onChangePaid(data) {
    this.debt = (+this.convertedSumTotal) - (+data.value);
    if (this.debt < 0) {
      this.debt = 0;
    }
    this.debt = (+this.debt.toFixed(2));
  }

  delete(index: any) {
    this.messageDisplay = true;
    this.deleteIndex = index;
  }



  OnAgreeDelete() {
    this.saleItemCart.splice(this.deleteIndex, 1);
    this.deleteIndex = null;
    this.messageDisplay = false;
    this.calculateSumTotal();
    this.save();
  }

  OnDegreeDelete() {
    this.messageDisplay = false;
  }

  save() {
    console.log(this.saleItemCart);
    this.saleItemCart = this.saleItemCart.map((value, index) => { value.index = index; return value; });

    this.saleItemCartLoading = true;

    if (this.saleCart[this.id]) {
      this.saleCart[this.id].sum_total = (+this.convertedSumTotal).toFixed(2);
      this.saleCart[this.id]['items'] = this.saleItemCart;
    }
    localStorage.setItem('sales', JSON.stringify(this.saleCart));
    this.saleItemCartLoading = false;
  }

  saveOnlySaveCart() {
    localStorage.setItem('sales', JSON.stringify(this.saleCart));
  }

  update(data) {
    this.saleItemCart[this.productIndexModal].count = data.value.count;
    this.saleItemCart[this.productIndexModal].total = (data.value.count * this.saleItemCart[this.productIndexModal].retail_price).toFixed(2);
    this.saleItemCart[this.productIndexModal].total_converted_retail_price = (data.value.count * this.saleItemCart[this.productIndexModal].converted_retail_price).toFixed(2);
    this.countProductModal = false;
    this.calculateSumTotal();
    this.save();
  }

  onAddAllSaleCartItems(){
    console.log(this.selectedSaleCartItems);
    for(let i=0;i<this.selectedSaleCartItems.length;i++){
      this.addCart(this.selectedSaleCartItems[i]);
    }
    this.selectedSaleCartItems=[];
  }

  addCart(data) {
    console.log(data);

    let tmpindex;


    for (let item in this.saleItemCart) {
      if (this.saleItemCart[item].product.id == data.product.id) {
        tmpindex = item;
      }
    }


    if (tmpindex) {
      this.saleItemCart[tmpindex].count = (+this.saleItemCart[tmpindex].count) + (+1);
      this.saleItemCart[tmpindex].total = this.saleItemCart[tmpindex].count * data.retail_price;
      this.saleItemCart[tmpindex].total_converted_retail_price = this.saleItemCart[tmpindex].count * data.converted_retail_price;
    } else {
      this.saleItemCart.push({
        product: data.product,
        currency: data.currency,
        retail_price: data.retail_price,
        converted_retail_price: data.converted_retail_price,
        store: data.store,
        count: 1,
        total: data.retail_price,
        total_converted_retail_price: data.converted_retail_price,
      });
    }


    this.calculateSumTotal()
    this.save();
    this.onLoad();
    this.saleItemSearchCart = [];
    this.saleItemSearchCartVisible = false;
    this.textSku = "";
    this.textName = "";
  }

  search(event, attribute) {
    console.log(event);
    console.log(attribute);
    this.saleItemSearchCart = [];
    this.saleItemSearchCartVisible = true;
    this.saleItemSearchCartLoading = true;

    this.productStorageService.getProductStorageByFilter([{ name: attribute, value: event.query }],0,this.store_id,1).subscribe(response => { this.saleItemSearchCart = response['data']; this.saleItemSearchCartLoading = false; })
    // this.saleItemService.searchProductByAttribut({'name': event.query})
    // .subscribe(response=>{this.productsForGrid=response['data'];this._searchGrid=true;});
  }

  onSearchKeyUp(value) {

    switch (value) {
      case 'sku':
        if (this.textSku.length < 1) {
          this.saleItemSearchCartVisible = false;
        }
        break;

      case 'name':
        if (this.textName.length < 1) {
          this.saleItemSearchCartVisible = false;
        }
        break;
    }

  }


  calculateSumTotal() {
    this.sumTotal = this.saleItemCart.reduce(function (sum: any, item: any) { return (+sum) + (+item.total); }, 0);
    this.sumTotal = this.sumTotal.toFixed(2);
    this.convertedSumTotal = this.saleItemCart.reduce(function (sum: any, item: any) { return (+sum) + (+item.total_converted_retail_price); }, 0);
    this.convertedSumTotal = this.convertedSumTotal.toFixed(2);
  }

  onRowSelect(event: any) {
    console.log(event.data);
    this.productNameModal = event.data.product.name;
    this.productSkuModal = event.data.product.sku;
    // this.productIdModal=event.data.product.id;
    this.productCountModal = event.data.count;
    this.productIndexModal = event.data.index;
    // this.storeIdModal=this.;
    // this.productItemIdModal=event.data.id;
    this.saleTypeModal = 1;
    this.countProductModal = true;
  }

  cancel(): void {
    this._location.back();
  }

  onShowQuickRegistrModal() {
    this.quickRegistrModal = true;
    this.positionService.getPosition().subscribe(response => {
      this.contact.positions = response['data'].map(function (value: any) {
        return { label: value.name, value: value.id };
      });
    })

    this.contact.genders.push({label: "Мужской", value: "0"});
    this.contact.genders.push({label: "Женский", value: "1"});

    this.selectedContractor = this.contractor.id;

    this.contractorService.getContractorList().subscribe(response => {
      this.contact.contractors = response['data'].map(function (value: any) {
        return { label: value.name, value: value.id };
      });
    })

    

  }

  onAddQuickRegistr(form: NgForm) {
     this.loadingQuickRegistr = true;
      form.value['available']=true;
      this.contactService.createContact(form.value).subscribe(response=>{
         
        Observable.forkJoin(
          this.contactService.getContactListByFilter([{ name: 'contractor_id', value: this.contractor.id }]),
          this.contactService.getContactListByFilter([{ name: 'contractor_id', value: '62e26f37-f6b0-4452-a4fb-e40fa1cd6b86' }])
        ).subscribe(response=>{
         let contact1 = response[0]['data'].map(function (value: any) {
                return { label: value.full_name, value: value.id };
              });
         let contact2 = response[1]['data'].map(function (value: any) {
           return { label: value.full_name, value: value.id };
         });
              this.contacts = contact1.concat(contact2);

              this.loadingQuickRegistr=false;
              this.quickRegistrModal = false;
        })

        this.selectedContactDriver = response['data'].id;  

      })
  }

  showModal(): void {
    this.paidValue = 0;
    this.onChangePaid({value: 0});
    this._display = true;
  }

  issue(form: NgForm) {

    let items = this.saleItemCart.map(data => {
      return {
        product_id: data.product.id,
        store_id: data.store.id,
        count: data.count
      }
    });

    let data = {
      contractor_id: this.contractor.id,
      paid_purpose: this.paidPurpose,
      deadline_repayment: form.value['deadlineReplenishment'],
      with_whom_contact_id: this.selectedContact,
      driver_contact_id: this.selectedContactDriver,
      used_bonus: form.value['used_bonus'],
      on_credit: 100,
      store_id: this.store_id,
      items: items,
      paid: form.value.paid || 0
    };
    this.blocked = true;
    this.saleService.issueSale(data).subscribe(response => {
      this.saleCart.splice(this.id, 1);
      this.saveOnlySaveCart();
      this.router.navigate(['/dashboard/sale']);
    },(error)=>{
      this.blocked = false;
    });

  }

  backClicked() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/sales/sale-items/sale-items.component.ts